import { ref } from "vue";
import { MIN_PHOTOS } from "../slideshow/playlist";
import { type CardId, selectionPhase, type TrackedPhase } from "./cards";

/** The mobile bottom bar's middle button. Sign-up never goes there. */
export type BarButton = "flowers" | "memorial_gift" | "photos" | "life_story";

/** The bar's choice, for the greeting field, which is a separate app. */
export const barMiddle = ref<BarButton | null>(null);

/**
 * Follows the highlights block: flowers while our shop takes orders, otherwise the memorial
 * gift. After the ceremony a page with few photos asks for more, and a life story plays.
 */
export function barButton(
  phase: TrackedPhase,
  cards: CardId[],
  photoCount: number
): BarButton | null {
  const after = ["first_year", "after_first_year"].includes(
    selectionPhase(phase)
  );
  if (after && cards.includes("photos") && photoCount < MIN_PHOTOS) {
    return "photos";
  }
  if (after && cards.includes("life_story")) {
    return "life_story";
  }
  if (cards.includes("flowers")) {
    return "flowers";
  }
  if (cards.includes("memorial_gift")) {
    return "memorial_gift";
  }
  return cards.includes("photos") ? "photos" : null;
}
